/*  MUI  */
import { ExpandMore, SendRounded } from '@mui/icons-material';
import {
    Box,
    Button,
    FormControl,
    Grid,
    MenuItem,
    Paper,
    Select,
    TextField,
    Typography
} from '@mui/material';

/*  Shared  */
import { FontSizes } from 'application/Shared/Constants';
import { Helpers, Notify, Response } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'router/withRouter';

/*  State  */
const state = () => ({
    endpoint: '',
    event: 'orgUsageDaily',
    loaded: false
});

class CreateWebhook extends Component {
    constructor(props) {
        super(props);
        this.state = state();
    }

    componentDidMount() {
        this.load();
    }

    load = () => {
        this.setState({ loaded: true });
    };

    close = () => {
        const { onClose } = this.props;

        if (onClose) {
            onClose();
        }
    };

    test = async () => {
        const payload = this.makePayload();
        if (!payload) {
            return;
        }

        Notify.i('Sending Test Payload');
        try {
            await axios.post('/webhook/test', payload);
            Notify.s('Test sent successfully!');
        } catch (e) {
            debug.e('Webhook Test Error', e);

            if (Helpers.isset(e, 'response', 'data', 'error')) {
                Notify.e(`Webhook Failed '${e.response.data.error}'`, {
                    seconds: 5
                });
                return;
            }

            Notify.e('Webhook Failed');
        }
    };

    save = async () => {
        const { match } = this.props;
        const { clientId } = match.params;
        const payload = this.makePayload();
        if (!payload) {
            return;
        }

        if (clientId) {
            payload.platformTenantId = clientId;
        }

        const err = 'Unable to save Webhook';
        try {
            const response = await axios.post('/webhook', payload);
            if (!Response.hasData(response)) {
                debug.e('No data returned on POST', response);
                Notify.e(err);
                return;
            }

            Notify.s('Webhook saved successfully.');
            this.close();
        } catch (e) {
            debug.e('Error adding Webhook', e);
            Notify.e(err);
        }
    };

    makePayload = () => {
        const { event } = this.state;

        let { endpoint } = this.state;
        try {
            endpoint = new URL(endpoint);
        } catch (e) {
            Notify.e('Invalid URL entered');
            debug.e(e);
            return false;
        }

        return { endpoint, event };
    };

    renderEvents = () => {
        const { t } = this.props;
        const { event } = this.state;

        // TODO: Get a config of available events from backend. Right now there's only 1 event
        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography color="textSecondary" fontWeight={600}>
                        {t('Common.event')}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Select
                        IconComponent={ExpandMore}
                        value={event}
                        onChange={(e) =>
                            this.setState({ event: e.target.value })
                        }
                        style={{ width: '100%' }}
                    >
                        <MenuItem key="orgUsageDaily" value="orgUsageDaily">
                            {t('Nightly Digest of Daily App Usage')}
                        </MenuItem>
                    </Select>
                </Grid>
            </Grid>
        );
    };

    renderEndpoint = () => {
        const { t } = this.props;
        const { endpoint } = this.state;

        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography color="textSecondary" fontWeight={600}>
                        {t('Common.url')}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        autoFocus
                        onChange={(e) =>
                            this.setState({ endpoint: e.target.value })
                        }
                        fullWidth
                        value={endpoint}
                        variant="standard"
                        placeholder="https://api.saaslio.com/webhook"
                    />
                </Grid>
            </Grid>
        );
    };

    renderActions = () => {
        const { t } = this.props;

        return (
            <Box display="flex" justifyContent="flex-end">
                <Button
                    onClick={() => this.close()}
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: '8px' }}
                    data-trackid="admin_utilities_webhooks_create_cancel"
                >
                    {t('Common.cancel')}
                </Button>

                <Button
                    variant="contained"
                    color="primary"
                    sx={{ marginRight: '8px' }}
                    onClick={() => this.test()}
                    data-trackid="admin_utilities_webhooks_create_test"
                >
                    <SendRounded
                        style={{ fontSize: FontSizes[1], marginRight: '4px' }}
                    />
                    {t('Common.test')}
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={() => this.save()}
                    data-trackid="admin_utilities_webhooks_create_save"
                >
                    {t('Common.save')}
                </Button>
            </Box>
        );
    };

    render() {
        const { t } = this.props;
        const { loaded } = this.state;

        if (!loaded) {
            return null;
        }

        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="h5">
                        {t('Common.configure')}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Paper elevation={0}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <FormControl
                                    fullWidth
                                    variant="standard"
                                    style={{ padding: '8px' }}
                                >
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            {this.renderEvents()}
                                        </Grid>
                                        <Grid item xs={12}>
                                            {this.renderEndpoint()}
                                        </Grid>
                                    </Grid>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                {this.renderActions()}
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        );
    }
}

export default withRouter(withTranslation()(CreateWebhook));
